"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * setTimeout as Promise.
 *
 * @param {number} ms Timeout in milliseconds.
 */
exports.delay = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/tools/delay.js
// module id = 1251
// module chunks = 71